/**
 * Styled Components - Created by gustavomedina on 05/06/18.
 */
import styled from 'styled-components'

export const Container = styled.div`
  padding: 27px 0;
  background-color: #fff;
  box-shadow: 0px 5px 14px 4px #c7c7c7;
  margin: 0 auto;
  padding-top: 0;
  min-height: 80vh;
  display: flex;
  flex-flow: column;
  .yotpo-pictures-widget {
    margin-top: 0px;
    .yotpo-pictures-gallery-header-wrapper {
      margin-bottom: 0px;
    }
  }
  @media (min-width: 1441px) {
    max-width: 1170px;
  }
  @media (min-width: 1700px) {
    max-width: 1298px;
  }
  @media (min-width: 1900px) {
    max-width: 1324px;
  }
  @media (min-width: 2200px) {
    max-width: 1400px;
  }
  @media (max-width: 1440px) {
    max-width: 1080px;
  }
  @media (max-width: 1240px) {
    max-width: 1012px;
  }
  animation: fade-in-bottom 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) 1s both;
  @keyframes fade-in-bottom {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const TitleBold = styled.div`
  text-align: center;
  margin-bottom: 44px;
  font-size: 18px;
  font-weight: bold;
  font-family: Avenir;
  margin-top: 44px;
  @media (max-width: 760px) {
    order: 0;
    margin-top: 0px;
    margin-bottom: 20px;
  }
`

export const RewardLogo = styled.div`
  transform: scale(0.65);
  position: absolute;
  right: 26px;
  top: -12px;
  @media (max-width: 760px) {
    position: unset;
    margin-top: -24px;
    margin-bottom: -50px;
    transform: scale(0.55);
    order: -1;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Reviews/styledComponents.tsx